import { defineExperience } from './helpers';

export const appExperience = defineExperience({
  id: 'app',
  owner: 'platypus-squad',
});

export const paymentsExperience = defineExperience({
  id: 'payments',
  owner: 's4x-moneybadger',
});

export const canvasExperience = defineExperience({
  id: 'canvas',
  owner: 'creator-enhance',
});

export const storylinesExperience = defineExperience({
  id: 'storylines',
  owner: 'creator-enhance',
});
